export default {
  example: 'Example',
  enableNotificationsMessage: 'Enable notifications in your device settings',
  auth: 'Chat widget authentication',
  appearance: 'Appearance',
  customization: 'Advanced',
  schedules: 'Hours',
  script: 'Install',
  ending: 'Auto-close',
  addScript: 'To add the chat widget to your website, copy and paste the following script in the footer of your website',
  copyScript: 'Copy script',
  editBrand: 'Edit business',
  prefix: 'Prefix',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  enterPrefix: 'Enter prefix',
  configuration: 'Settings',
  brandUpdated: 'Account updated',
  administrators: 'Users',
  administrator: 'User',
  administratorNumber: 'User\'s phone number',
  addAdministrator: 'Add team member',
  createNew: 'Create new',
  selectAdminType: 'Select user type',
  doYouWantTheAdminToBeInactive: 'Do you want the user to be inactive?',
  selectAdminPermissions: 'Select user\'s permissions',
  addPassword: 'Set a password',
  youreAboutToDeleteTheSelectedAdmin: 'You´re about to delete the selected user',
  adminDeleted: 'User deleted',
  youreAboutToDeleteTheSelectedAdminFromApp: 'You´re about to delete the selected user from the app',
  adminDeletedFromApp: 'User deleted from app',
  passwordSent: 'Password sent',
  of: 'of',
  wizardReport: 'Wizard Report',
  downloadReport: 'Download Report',
  wizardReportSuccess: 'Wizard Report generated and sent to your email successfully',
  wizardReportError: 'Error while generating Wizard Report',
  closeConversation: 'Close conversation',
  transferConversation: 'Transfer conversation',
  es: 'Spanish',
  en: 'English',
  inviteTeam: 'Invite your team',
  managePassword: 'Manage password',
  generateAffiliateLink: 'Generate affiliate link',
  language: 'Language',
  notificationsAlerts: 'Notifications & Alerts',
  changeLanguage: 'Change language',
  mine: 'Mine',
  all: 'All',
  waiting: 'Waiting',
  connectChannels: 'Connect channels',
  comingSoon: 'Coming soon',
  writeYourSearch: 'Type your search',
  didntFindExtradata: 'Custom field not found',
  generalSettings: 'Advance',
  apps: 'Apps',
  consumptionsAndPayments: 'Billing and Payment',
  autoAssign: 'Conversation Routing',
  domains: 'Domains',
  configKeybeApp: 'Configure your Keybe App',
  general: 'General',
  website: 'Website',
  chats: 'Smart chat',
  autoassign: 'Conversation Routing',
  domain: 'Domain',
  pipelinesProperties: 'Pipelines properties',
  deleteUser: 'Delete person',
  deleteUserFromApp: 'Delete person from app',
  cantDeleteUserFromApp: 'In order to delete a person from the app it must be associated with other apps',
  reassign: 'Reassign',
  reassignInactiveConversations: 'Reassign inactive conversations',
  withAnAgent: 'With a user',
  withABot: 'With a bot',
  reassignAfter: 'Reassign after',
  profilePicUpdated: 'Profile picture updated',
  errorUpdatingProfilePic: 'Error updating profile picture',
  errorUploadingPicture: 'Error uploading picture',
  dependsOn: 'Depends on',
  noDependencies: 'No dependencies',
  deleteRolText: 'Youre about to delete the selected rol',
  rolDeleted: 'Rol deleted',
  type: 'Type',
  selectAnOption: 'Select',
  center: 'Center',
  yourTeam: 'Your Team',
  createTeamMember: 'Create team member',
  editTeamMember: 'Edit team member',
  addPeopleToYourTeam: 'Add people to your team',
  authenticator: 'Authenticator',
  sequences: 'Sequences',
  directory: 'Directory',
  events: 'Events',
  oldevents: 'Old Events',
  lists: 'Lists',
  payments: 'Payments',
  triggers: 'Triggers',
  partners: 'Partners',
  catalog: 'Catalog',
  minimumOneProductRequired: 'A minimum of one product is required',
  catalogCreatedSuccessfully: 'Catalog created successfully',
  catalogEditedSuccessfully: 'Catalog edited successfully',
  catalogCreatedFail: 'Catalog created fail',
  catalogEditedFail: 'Catalog edited fail',
  iWantToSeeIt: 'I want to see!',
  connectionHistory: 'Connection history',
  device: 'Device',
  ip: 'IP',
  browser: 'Browser',
  loggedOutSuccessfully: 'Logged out successfully',
  activeDevices: 'Active sessions',
  howToUseKeybe: 'How to use KB:',
  whatsAppChat: 'WhatsApp Chat',
  noRolesFoundForUser: 'No roles found',
  darkMode: 'Dark mode',
  activeMode: 'Active',
  invoiceDetails: 'Invoice details',
  Viewuser: 'View user',
  Deleteuser: 'Delete user',
  Adduser: 'Add user',
  Updateuser: 'Update user',
  Inviteuser: 'Invite user',
  Configureusercall: 'Configure user call',
  Conversations: 'Conversations',
  ConfigureConversations: 'Configure Conversations',
  Viewallchats: 'View all conversations',
  Viewalluserchats: 'View all user conversations',
  Filterallchats: 'Filter all conversations',
  Filterwaitingchats: 'Filter waiting conversations',
  Filterendchats: 'Filter closed conversations',
  'Transferchattootherusers->': 'Transfer chat to other users',
  'Transferchatstotheuser<-': 'Transfer conversations to the user',
  Applyautoassignationrules: 'Apply auto assignation rules',
  Takeconversationsfrombot: 'Take conversations from bot',
  Takechatfromagent: 'Take conversation from agent',
  Endchat: 'End conversation',
  Sendpdfinchat: 'Send PDF in conversation',
  Sendimagesinchat: 'Send images in conversation',
  Sendaudiosinchat: 'Send audios in conversation',
  Viewrecordsfromchat: 'View records from conversation',
  campaigns: 'campaigns',
  ViewCampaigns: 'View Campaigns',
  CreateCampaigns: 'Create Campaigns',
  SendCampaigns: 'Send Campaigns',
  ViewList: 'View List',
  CreateList: 'Create List',
  ViewForms: 'View Forms',
  CreateForms: 'Create Forms',
  DeleteForms: 'Delete Forms',
  Viewallrecords: 'View all records',
  Viewmyrecords: 'View my records',
  Createrecords: 'Create records',
  Editrecords: 'Edit records',
  Importrecords: 'Import records',
  Exportrecords: 'Export records',
  Deleterecords: 'Delete records',
  Disablerecords: 'Disable records',
  Addrecordstolist: 'Add records to list',
  Downloadrecordscard: 'Download records card',
  SendEmailtorecords: 'Send Email to records',
  Changeeditionmode: 'Change edition mode',
  ViewRoles: 'View Roles',
  CreateRoles: 'Create Roles',
  DeleteRoles: 'Delete Roles',
  Sethabeasdatafortherecord: 'Set habeas data for the record',
  ViewDocuments: 'View Documents',
  UploadDocuments: 'Upload Documents',
  DownloadDocuments: 'Download Documents',
  EditDocumentsDescription: 'Edit Document Description',
  DeleteDocuments: 'Delete Documents',
  ViewJourneys: 'View Status',
  CreateJourneys: 'Create Status',
  DeleteJourneys: 'Delete Status',
  ViewCharges: 'View Charges',
  ExportCharges: 'Export Charges',
  Payamount: 'Pay amount',
  ViewTriggers: 'View Triggers',
  CreateTriggers: 'Create Triggers',
  EmitCustomEventTrigger: 'Send Custom Event Trigger',
  CreateBusiness: 'Create Business',
  ViewBusiness: 'View Business',
  DeleteBusiness: 'Delete Business',
  ImportBusiness: 'Import Business',
  CreateBusinessContact: 'Create Business Contact',
  DeleteBusinessContact: 'Delete Business Contact',
  ModifiedAuthenticator: 'Modify Authenticator',
  CreateTemplates: 'Create Templates',
  DeleteTemplates: 'Delete Templates',
  ViewTemplates: 'View Templates',
  DisableTriggers: 'Disable triggers',
  open: 'Open',
  rebound: 'Rebound',
  mandatoryOnStepEnter: 'Mandatory on step enter',
  mandatoryOnStepLeave: 'Mandatory on step leave',
  Client: 'Client',
  Trainer: 'Trainer',
  SendDirectsmstorecords: 'Send direct sms to records',
  Call: 'Call',
  Viewrules: 'View rules',
  Createrules: 'Create rules',
  Deleterules: 'Delete rules',
  ViewSequences: 'View sequences',
  DeleteSequences: 'Delete sequences',
  InitSequences: 'Init sequences',
  StopSequences: 'Stop sequences',
  ViewServiceHours: 'View service hours',
  CreateServiceHours: 'Create service hours',
  DeleteServiceHours: 'Delete service hours',
  ViewEvents: 'View events',
  AddEventsAttendees: 'Add events attendees',
  CheckingEvents: 'Check-in events',
  CreateEvents: 'Create events',
  DeleteEvents: 'Delete events',
  Viewactivities: 'View activities',
  Createactivity: 'Create activity',
  Updateactivity: 'Update activity',
  Deleteactivity: 'Delete activity',
  Eventscheckingattendess: 'Check-in event attendees',
  Eventsgetlistofattendess: 'Get attendees list',
  // TODAY WE PRESENT KB: FLOWS
  kbFlowsPopUpTitle: 'Today we present KB: Flows',
  kbFlowsPopUpDescription: 'Design workflows, connect apps, streamline sales processes. Automate everything with KB: Flows.',
  wantMoreInfo: 'Learn more',
  weWillContactYou: 'We will be in touch!',
  weWillContactYouDescription: 'One of our specialists will contact you to accompany you in these first steps.',
  knowKbFlows: 'Know KB Flows',
  kbFlowsVideo: 'https://www.youtube.com/embed/roA0PvcszSA',
  youCantEditAUserOtherThanYourself: 'You can\'t edit a team member other than yourself'
}
